import useLocalStorageObj from './useLocalStorageObj'

export default function useConfigStepsStorage() {
  const ops = useLocalStorageObj('configSteps');
  return {
    configSteps:ops.getObj,
    setConfigSteps:ops.setObj   
  }
}
